import {Injectable} from '@angular/core';

import {TranslateService} from "@ngx-translate/core";
import { setDay } from 'date-fns';

import {LanguageService} from "@shared/services/language.service";

import {OptionItem} from "@commons/models/other/option-item.model";

@Injectable({
  providedIn: 'root'
})
export class TranslateHelperService {

  today ='';
  sensor = '';

  constructor(
    private languageService: LanguageService,
    private translateService: TranslateService
  ) {
    this.setTranslations();
  }

  private setTranslations() {
    this.translateService.get('labels.sensor').subscribe(t => this.sensor = t);
    this.translateService.get('date-time.today').subscribe(t => this.today = t);
  }

  firstLetterToUppercase(word: string): string {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }

  getFullMonthName(monthIndex: number) {
    const date = new Date();
    date.setDate(1);
    date.setMonth(monthIndex - 1);

    const month = date.toLocaleString(this.languageService.current, {month: "long"});

    return month;
  }

  getAllFullMonthsNames(): string[] {
    let result = [];
    for (let i = 1; i <= 12; i++)
      result.push(this.getFullMonthName(i));

    return result;
  }

  getWeekDaysFirstLetterNames(): string[] {
    let result: string[] = [];
    let date = new Date();

    for (let i = 0; i < 7;i++) {
      date = setDay(date, i);
      const month = date.toLocaleString(this.languageService.current, {weekday: "long"});
      result.push(month[0].toUpperCase());
    }

    return result;
  }

  translateOptionItems(items: OptionItem[], firstLetterToUpper = false): OptionItem[] {
    for (const item of items) {
      if (item.label)
        this.translateService.get(item.label).subscribe(t => {
          item.label = firstLetterToUpper ? this.firstLetterToUppercase(t) : t;
        });
    }

    return items;
  }

}
